<p-panel
  [toggler]="'header'"
  [toggleable]="false"
  [collapsed]="false"
  styleClass="dashboard-news-panel"
>
  <ng-template pTemplate="header">
    <div class="dashboard-news-panel__header">
      <div class="dashboard-news-panel__title-wrap">
        <div class="dashboard-news-panel__icon">
          <i class="pi pi-megaphone"></i>
        </div>

        <div class="dashboard-news-panel__title">
          Последние новости
        </div>
      </div>


    </div>
  </ng-template>

  <div class="dashboard-news" *ngIf="content?.length; else emptyState">
    <div
      class="dashboard-news__item"
      *ngFor="let card of content | slice:0:3"
    >
      <div class="dashboard-news__date">
        {{ card.news_date | date: 'dd.MM.y' }}
      </div>

      <div class="dashboard-news__body">
        <div class="dashboard-news__content" [innerHTML]="card.safe_news_content"></div>
      </div>
    </div>
    <button
      type="button"
      class="dashboard-news-panel__all"
      (click)="$event.stopPropagation(); goToAllNews()"
    >
      <span>Все новости</span>
      <i class="pi pi-angle-right"></i>
    </button>
  </div>

  <ng-template #emptyState>
    <div class="dashboard-news__empty">
      <i class="pi pi-info-circle"></i>
      <span>Новостей пока нет</span>
    </div>
  </ng-template>
</p-panel>
